import { __makeTemplateObject } from '../_virtual/_tslib.js';
import styled from 'styled-components';

var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var NumberContainer = styled(Container)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  gap: 0.8rem;\n  margin: 0 1.6rem;\n"], ["\n  gap: 0.8rem;\n  margin: 0 1.6rem;\n"])));
var Button = styled.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  width: 4rem;\n  height: 4rem;\n  border-radius: 0.4rem;\n  border: none;\n  cursor: ", ";\n\n  color: ", ";\n  background-color: ", ";\n\n  :hover {\n    background-color: ", ";\n  }\n  :active {\n    background-color: ", ";\n  }\n  :disabled {\n    background-color: ", ";\n    color: ", ";\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  width: 4rem;\n  height: 4rem;\n  border-radius: 0.4rem;\n  border: none;\n  cursor: ", ";\n\n  color: ", ";\n  background-color: ", ";\n\n  :hover {\n    background-color: ", ";\n  }\n  :active {\n    background-color: ", ";\n  }\n  :disabled {\n    background-color: ", ";\n    color: ", ";\n  }\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'default' : 'pointer');
}, function (_a) {
    var theme = _a.theme;
    return theme.colorTokens.text.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.colorTokens.background.base;
}, function (_a) {
    var theme = _a.theme;
    return theme.colorTokens.hierarchy.h5;
}, function (_a) {
    var theme = _a.theme;
    return theme.colorTokens.hierarchy.h4;
}, function (_a) {
    var theme = _a.theme;
    return theme.colorTokens.background.base;
}, function (_a) {
    var theme = _a.theme;
    return theme.colorTokens.text.disabled;
});
var IconButton = Button;
var NumberButton = styled(Button)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n"], ["\n  background-color: ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme, isSelected = _a.isSelected;
    return isSelected
        ? theme.colorTokens.accent.default + " !important"
        : theme.colorTokens.background.base;
}, function (_a) {
    var theme = _a.theme, isSelected = _a.isSelected;
    return isSelected
        ? theme.colorTokens.accent.on + " !important"
        : theme.colorTokens.text.primary;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

export { Container, IconButton, NumberButton, NumberContainer };
